/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const ArrowDown = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M20 12.9484L13.2328 19.7413C12.8941 20.0813 12.0039 21 12.0039 21C12.0039 21 11.1094 20.0848 10.7672 19.7413L4 12.9484L5.05665 11.8878L11.2528 18.1075L11.2528 2.25391H12.7472V18.1075L18.9433 11.8878L20 12.9484Z"
                        fill={color}
                    />
                </svg>
        );
    };
